import { render, staticRenderFns } from "./EditShiftTypeComponent.vue?vue&type=template&id=ee81171c&scoped=true"
import script from "./EditShiftTypeComponent.vue?vue&type=script&lang=js"
export * from "./EditShiftTypeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee81171c",
  null
  
)

export default component.exports